/**
 * Datos mock de vehículos para listados.
 */
export const VEHICLES = [
  {
    id: '1',
    code: 'VH-2024-001',
    image: 'https://images.unsplash.com/photo-1494976388531-d1058494cdd8?w=600',
    images: [
      'https://images.unsplash.com/photo-1494976388531-d1058494cdd8?w=1200',
      'https://images.unsplash.com/photo-1502877338535-766e1452684a?w=1200',
      'https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?w=1200',
    ],
    title: 'Toyota Corolla 2024',
    brand: 'Toyota',
    model: 'Corolla',
    year: 2024,
    price: 28500,
    priceTo: null,
    location: 'Santo Domingo, Zona Colonial',
    doors: 4,
    transmission: 'automática',
    fuel: 'gasolina',
    mileage: 12000,
    condition: 'nuevo',
    type: 'sedán',
  },
  {
    id: '2',
    code: 'VH-2023-002',
    image: 'https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=600',
    images: [
      'https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=1200',
      'https://images.unsplash.com/photo-1494976388531-d1058494cdd8?w=1200',
      'https://images.unsplash.com/photo-1544636331-e2687cd539d3?w=1200',
    ],
    title: 'Honda CR-V 2023',
    brand: 'Honda',
    model: 'CR-V',
    year: 2023,
    price: 32000,
    priceTo: 35000,
    location: 'Santiago, Las Colinas',
    doors: 4,
    transmission: 'automática',
    fuel: 'gasolina',
    mileage: 25000,
    condition: 'usado',
    type: 'suv',
  },
  {
    id: '3',
    code: 'VH-2024-003',
    image: 'https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=600',
    images: [
      'https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=1200',
      'https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=1200',
      'https://images.unsplash.com/photo-1494976388531-d1058494cdd8?w=1200',
    ],
    title: 'BMW Serie 3 2024',
    brand: 'BMW',
    model: 'Serie 3',
    year: 2024,
    price: 45000,
    priceTo: null,
    location: 'Santo Domingo, Naco',
    doors: 4,
    transmission: 'automática',
    fuel: 'gasolina',
    mileage: 5000,
    condition: 'nuevo',
    type: 'sedán',
  },
  {
    id: '4',
    code: 'VH-2022-004',
    image: 'https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=600',
    images: [
      'https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=1200',
      'https://images.unsplash.com/photo-1544636331-e2687cd539d3?w=1200',
      'https://images.unsplash.com/photo-1502877338535-766e1452684a?w=1200',
    ],
    title: 'Ford Ranger 2022',
    brand: 'Ford',
    model: 'Ranger',
    year: 2022,
    price: 38000,
    priceTo: null,
    location: 'La Romana, Centro',
    doors: 4,
    transmission: 'automática',
    fuel: 'diésel',
    mileage: 42000,
    condition: 'usado',
    type: 'camioneta',
  },
  {
    id: '5',
    code: 'VH-2024-005',
    image: 'https://images.unsplash.com/photo-1502877338535-766e1452684a?w=600',
    images: [
      'https://images.unsplash.com/photo-1502877338535-766e1452684a?w=1200',
      'https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?w=1200',
      'https://images.unsplash.com/photo-1494976388531-d1058494cdd8?w=1200',
    ],
    title: 'Mazda CX-5 2024',
    brand: 'Mazda',
    model: 'CX-5',
    year: 2024,
    price: 33500,
    priceTo: null,
    location: 'Santo Domingo, Piantini',
    doors: 4,
    transmission: 'automática',
    fuel: 'gasolina',
    mileage: 8000,
    condition: 'nuevo',
    type: 'suv',
  },
  {
    id: '6',
    code: 'VH-2021-006',
    image: 'https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?w=600',
    images: [
      'https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?w=1200',
      'https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=1200',
      'https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=1200',
    ],
    title: 'Hyundai Tucson 2021',
    brand: 'Hyundai',
    model: 'Tucson',
    year: 2021,
    price: 22000,
    priceTo: 24500,
    location: 'Charco Blanco, La Ciénaga',
    doors: 4,
    transmission: 'automática',
    fuel: 'gasolina',
    mileage: 55000,
    condition: 'usado',
    type: 'suv',
  },
]
